import popupModel from '@/model/popup';
import userModel from '@/model/user';
import store from '@/store';

import CompanyFormPopupWrappable from '@/components/company/CompanyFormPopupWrappable.vue';
import companyApi from '@/api/company';

export default {
  async addCompany() {
    const data = await popupModel.add({
      wrappable: true,
      component: CompanyFormPopupWrappable,
      params: {},
    });

    await companyApi.create(data, true);
    await userModel.fetchSelf();
  },
  async employeeDelete({ id, user }) {
    const answer = await popupModel.addConfirm(`Вы действительно хотите уволить сотрудника [${user.name} ${user.surname}]?`);
    if (!answer) return;
    await store.dispatch('company/deleteEmployee', { id });
  },
}
